import { execSafeSaga } from '@lib/helpers';
import { all, call, takeLeading, put } from 'redux-saga/effects';
import { getApplicantInfo, updateApplicantInfo, acceptApplicantProfile } from './funder-applicant.service';
import { actionType } from './action';
import Router from 'next/router';
import { refreshSession } from '@/auth/cognito.service';
import { getUserPrincipal } from '@services/user/action';


function* getApplicant() {
    const funder = yield call(getApplicantInfo);
    yield put({ type: actionType.SET_FUNDER_APPLICANT_PROFILE, payload: { ...funder } });
}

function* updateApplicantData(action) {
    yield execSafeSaga(function* () {
        const { payload } = action;
        yield call(updateApplicantInfo, payload);
        yield put({ type: actionType.RESET_STORE });
        Router.push('/registration/registration-review')
    });
}

function* acceptApplicantProfileSaga() {
    yield execSafeSaga(function* () {
        
        yield call(acceptApplicantProfile);
       
        yield all([
            call(refreshSession),
            put({ type: actionType.RESET_STORE })
        ]);

        Router.push('/registration/registration-complete');
    });
}

function* rootSaga() {
    yield all([
        takeLeading(actionType.FETCH_FUNDER_PROFILE_FORM, getApplicant),
        takeLeading(actionType.UPDATE_FUNDER_APPLICANT_PROFILE, updateApplicantData),
        takeLeading(actionType.ACCEPT_FUNDER_APPLICANT_PROFILE, acceptApplicantProfileSaga)
    ])
}

export default rootSaga;